import React from 'react';
import mapFormOperationalErrors from './mapFormOperationalErrors';

const CUSTOM_STATUSES = new Set([400, 409, 422]);

export default function handleSetupFormPreviewFailure({ response, showError }) {
   if (!response || response.status === 401 || response.status === 403) return false;
   if (!CUSTOM_STATUSES.has(response.status)) return false;

   const operationalErrors = response.data && response.data.content ? response.data.content.errors : null;
   if (response.status === 422 && Array.isArray(operationalErrors)) {
      const mapped = mapFormOperationalErrors({ errors: operationalErrors, items: response.input.items || [] });
      const message = React.createElement(
         'div',
         null,
         React.createElement('div', null, 'Preview cannot be generated:'),
         React.createElement(
            'ul',
            null,
            mapped.map((entry) => React.createElement('li', { key: `${entry.idFormItem}:${entry.message}` }, `“${entry.label}”: ${entry.message}`))
         )
      );
      showError({ message });
      return true;
   }

   showError({ message: response.data ? response.data.content : 'Unable to generate Preview.' });
   return true;
}
